<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina
                Titlu="Servicii programator"
                @on_add_clicked="show_dialog()"
                :AdaugaVisible="true"
              />
            </div>
          </template>
      <div class="filtre">
        <el-form @submit.prevent.native="refresh_info()">
          <el-row style="margin: 10px" class="input-group">
            <el-col class="input-element">
              <el-form-item label="Nume">
                <el-input v-model="Filters.Nume" />
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-button
                type="primary"
                native-type="submit"
                @click="refresh_info()"
              > 
                Aplica
              </el-button>
              <el-button type="danger" native-type="submit" @click="reset()">
                Reseteaza
              </el-button>
            </el-col>
          </el-row>
        </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table :data="Results">
      <!-- <el-table-column prop="Id" label="ID"></el-table-column> -->
      <el-table-column prop="OrderNo" label="Numar ordine"></el-table-column>
      <el-table-column prop="Nume" label="Nume"></el-table-column>
      <el-table-column prop="Pret" label="Pret"></el-table-column>
      <el-table-column prop="Descriere" label="Descriere"></el-table-column>
      <el-table-column prop="NumeCentru" label="Centru productie"></el-table-column>
      <el-table-column prop="DurataServiciu" label="Durata (sec)"></el-table-column>
      <el-table-column label="Iconita" align ="center">
        <template slot-scope="scope">
         <img style="width: auto; height: 50px; " :src="scope.row.Iconita"/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="110px">
        <template slot-scope="scope">
          <el-tooltip content="Modificare">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              @click="show_dialog(scope.row.Id)"
            />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="delete_item(scope.row)"
            /> 
          </el-tooltip>
        </template>
      </el-table-column
    ></el-table>
    <el-pagination
      @size-change="refresh_info"
      @current-change="refresh_info"
      :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page"
      :total="PaginationInfo.RowCount"
      layout="pager" />
    <Centre-productie-dialog class="custom-width" ref="dlg" @save="refresh_info()"
  /></base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Servicii_programator_dialog from "@/pages/Admin/servicii_programator/Servicii_programator_dialog.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "servicii_programator",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Centre-productie-dialog": Servicii_programator_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Results: [],
      base_url: "",
      Info: {},
      Filters: {
        Nume: "",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },

  
  methods: {
    async get_info() {
      var response = await this.post("servicii_programator/get_info");
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("servicii_programator/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      //
      this.select_menu_item("centre_productie");
    },
    reset() {
      this.Filters = {
        Nume: "",
      };
      this.refresh_info();
    },

    async delete_item(item) {
      var confirm = await this.$confirm(`Daca exista programari pe acest serviciu se pot genera erori. Sunteti sigur ?`, "Atentie!");
      if (confirm) {
        await this.post("servicii_programator/delete_item", { id: item.Id });
        this.refresh_info();
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right("Management")) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  width: 50%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
